import script from "./BasicSection.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicSection.vue?vue&type=script&setup=true&lang=js"

import "./BasicSection.vue?vue&type=style&index=0&id=9dbdc3d6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9dbdc3d6"]])

export default __exports__